import withStyles from '@mui/styles/withStyles';

import styles from './skeletonStyles';

export function ChipSkeleton({ classes = {}, style = {} }) {
  return <span className={classes.root} style={style} />;
}

/**
 * @deprecated
 * ### Description
 * `ChipSkeleton` has been deprecated and will not be replaced
 */
export default withStyles(styles)(ChipSkeleton);
